import { MonitorsRouter } from 'areas/assets/monitors/bundleDescription';
import { MonitorType } from 'areas/assets/monitors/monitorType';
import { RouteEntry } from 'framework/routing/routeEntry';
import { SystemMonitorPageProps } from 'areas/monitors/system-monitor/SystemMonitorPage/types';

// noinspection JSUnusedGlobalSymbols
export function getRoute(): RouteEntry<SystemMonitorPageProps> {
	return {
		url: MonitorsRouter.list(MonitorType.SystemNew) + '/:id',
		getModuleImport: async () => await import('areas/monitors/system-monitor/SystemMonitorPage'),
		routeId: 'monitors_system-new',
	};
}
